export default __webpack_public_path__ + "static/iphone-6873e631e645284d9f5c679f3d54d4aa.png";